<template>
  <div class="unselected_card">
    <p>データが不足しています。</p>
    <p>期間または店舗を変更してください。</p>
  </div>
</template>
